"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PrefetchedTokenProvider = void 0;
var _react = require("react");
var _constants = require("../constants");
var _internals = require("../internals");
var _isTokenValid = require("../utils/isTokenValid");
var _tokenContext = require("./tokenContext");
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated Use `UniversalTokenProvider` instead */ var PrefetchedTokenProvider = function(param) {
    var initialToken = param.token, customerId = param.customerId, children = param.children;
    var token = initialToken ? (0, _internals.cleanToken)(initialToken) : undefined;
    if (!token || !(0, _isTokenValid.isTokenValid)(token)) {
        throw new Error('Received an invalid token. It is either malformed or expired');
    }
    var contextValue = (0, _react.useMemo)(function() {
        return {
            token: token,
            formattedToken: "Bearer ".concat(token),
            customerId: customerId,
            isAnonymousUser: customerId === _constants.NOT_LOGGED_IN_USER_ID,
            isUserVerified: false
        };
    }, [
        customerId,
        token
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_tokenContext.tokenContext.Provider, {
        value: contextValue,
        children: children
    });
};
exports.PrefetchedTokenProvider = PrefetchedTokenProvider; //# sourceMappingURL=PrefetchedTokenProvider.js.map
